import { Injectable } from '@angular/core';
import { FormsAdapter } from './forms.adapter';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class FormsConnector {
  constructor(protected adapter: FormsAdapter) {}

  postAdvancedForm(url: string, body: HttpParams): Observable<any> {
    return this.adapter.postAdvancedForm(url, body);
  }

  postAdvancedFormFile(url: string, body: FormData): Observable<string> {
    return this.adapter.postAdvancedFormFile(url, body);
  }
}
